import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const eventTriggerTag = css`
  display: inline-block;
  color: white;
`;

export const mediumInfractionTag = css`
  background-color: rgba(240, 140, 0, 0.1);

  > svg,
  span {
    color: ${colors.warning.default};
  }
`;

export const seriousInfractionTag = css`
  background-color: rgba(225, 76, 0, 0.1);

  > svg,
  span {
    color: ${colors.warning.hover};
  }
`;

export const verySeriousInfractionTag = css`
  background-color: rgba(209, 22, 14, 0.1);

  > svg,
  span {
    color: ${colors.error.hover};
  }
`;

const baseTag = css`
  display: inline-flex;
  border-radius: 5px;
  padding: 5px 10px;
  > span {
    font-size: ${fonts.size.smallest};
    font-weight: ${fonts.weight.medium};
    font-style: normal;
  }
`;

export const finishedTag = css`
  ${baseTag};
  background-color: rgba(138, 185, 247, 0.3);
  > span {
    color: #0234E1;
  }
  > svg {
    color: #0234E1;
    width: 11px;
  }
`;

export const pendingTag = css`
  ${baseTag};
  background-color: rgba(157, 169, 182, 0.3);
  > span {
    color: #5d7186;
  }
  > svg {
    color: #5d7186;
    width: 11px;
  }
`;
